namespace TabAurous.Retail {
    export interface POSApprovalItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        TaxCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        MetalId?: number;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        DesignId?: number;
        DesignCode?: string;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        DeptName?: string;
        BOMDetails?: POSApprovalBOMRow[];
        LaborDetails?: POSApprovalLaborRow[];
        GroupId?: number;
        RoutingId?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        CategoryCode?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StampCode?: string;
        ProductSizeCode?: string;
        SuperTypeCode?: string;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        DiscountPer?: number;
        VoucherNo?: string;
        TransDate?: string;
        IsPosted?: boolean;
        CompanyCode?: string;
        CustomerName?: string;
        FirstName?: string;
        LastName?: string;
        HUID?: string;
        StampId?: number;
        ExportPieces?: number;
        MFAmount?: number;
        MF?: number;
        StoneRate?: number;
        OtherRate?: number;
        PurchaseVoucher?: string;
        PurchasePieces?: number;
        PurchaseWeight?: number;
        SalesVoucher?: string;
        SalesPieces?: number;
        SalesWeight?: number;
        RemainingPieces?: number;
        RemainingWeight?: number;
    }

    export namespace POSApprovalItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Retail.POSApprovalItems';
        export const deletePermission = 'Retail:POSApproval:Delete';
        export const insertPermission = 'Retail:POSApproval:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSApproval:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            TaxCode = "TaxCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            MetalId = "MetalId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeptName = "DeptName",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            GroupId = "GroupId",
            RoutingId = "RoutingId",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            CategoryCode = "CategoryCode",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StampCode = "StampCode",
            ProductSizeCode = "ProductSizeCode",
            SuperTypeCode = "SuperTypeCode",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            DiscountPer = "DiscountPer",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            IsPosted = "IsPosted",
            CompanyCode = "CompanyCode",
            CustomerName = "CustomerName",
            FirstName = "FirstName",
            LastName = "LastName",
            HUID = "HUID",
            StampId = "StampId",
            ExportPieces = "ExportPieces",
            MFAmount = "MFAmount",
            MF = "MF",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            PurchaseVoucher = "PurchaseVoucher",
            PurchasePieces = "PurchasePieces",
            PurchaseWeight = "PurchaseWeight",
            SalesVoucher = "SalesVoucher",
            SalesPieces = "SalesPieces",
            SalesWeight = "SalesWeight",
            RemainingPieces = "RemainingPieces",
            RemainingWeight = "RemainingWeight"
        }
    }
}
